import { render, staticRenderFns } from "./PSyncfusionRichTextEditor.vue?vue&type=template&id=7b63e3ac&"
import script from "./PSyncfusionRichTextEditor.vue?vue&type=script&lang=js&"
export * from "./PSyncfusionRichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./PSyncfusionRichTextEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports